"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _BatchSlideInfo = _interopRequireDefault(require("./BatchSlideInfo"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The BatchCreateMediaSlideCommand model module.
 * @module model/BatchCreateMediaSlideCommand
 * @version 1.1.3-alpha.1
 */
class BatchCreateMediaSlideCommand {
  /**
   * Constructs a new <code>BatchCreateMediaSlideCommand</code>.
   * @alias module:model/BatchCreateMediaSlideCommand
   * @param media_id {String} 
   * @param batch_id {String} 
   * @param is_topline {Boolean} 
   */
  constructor(media_id, batch_id, is_topline) {
    BatchCreateMediaSlideCommand.initialize(this, media_id, batch_id, is_topline);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, media_id, batch_id, is_topline) {
    obj['media_id'] = media_id;
    obj['batch_id'] = batch_id;
    obj['is_topline'] = is_topline;
  }

  /**
   * Constructs a <code>BatchCreateMediaSlideCommand</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/BatchCreateMediaSlideCommand} obj Optional instance to populate.
   * @return {module:model/BatchCreateMediaSlideCommand} The populated <code>BatchCreateMediaSlideCommand</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new BatchCreateMediaSlideCommand();
      if (data.hasOwnProperty('media_id')) {
        obj['media_id'] = _ApiClient.default.convertToType(data['media_id'], 'String');
      }
      if (data.hasOwnProperty('batch_id')) {
        obj['batch_id'] = _ApiClient.default.convertToType(data['batch_id'], 'String');
      }
      if (data.hasOwnProperty('is_topline')) {
        obj['is_topline'] = _ApiClient.default.convertToType(data['is_topline'], 'Boolean');
      }
      if (data.hasOwnProperty('slides')) {
        obj['slides'] = _ApiClient.default.convertToType(data['slides'], [_BatchSlideInfo.default]);
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>BatchCreateMediaSlideCommand</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>BatchCreateMediaSlideCommand</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of BatchCreateMediaSlideCommand.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['media_id'] && !(typeof data['media_id'] === 'string' || data['media_id'] instanceof String)) {
      throw new Error("Expected the field `media_id` to be a primitive type in the JSON string but got " + data['media_id']);
    }
    // ensure the json data is a string
    if (data['batch_id'] && !(typeof data['batch_id'] === 'string' || data['batch_id'] instanceof String)) {
      throw new Error("Expected the field `batch_id` to be a primitive type in the JSON string but got " + data['batch_id']);
    }
    if (data['slides']) {
      // data not null
      // ensure the json data is an array
      if (!Array.isArray(data['slides'])) {
        throw new Error("Expected the field `slides` to be an array in the JSON data but got " + data['slides']);
      }
      // validate the optional field `slides` (array)
      for (const item of data['slides']) {
        _BatchSlideInfo.default.validateJSON(item);
      }
      ;
    }
    return true;
  }
}
BatchCreateMediaSlideCommand.RequiredProperties = ["media_id", "batch_id", "is_topline"];

/**
 * @member {String} media_id
 */
BatchCreateMediaSlideCommand.prototype['media_id'] = undefined;

/**
 * @member {String} batch_id
 */
BatchCreateMediaSlideCommand.prototype['batch_id'] = undefined;

/**
 * @member {Boolean} is_topline
 */
BatchCreateMediaSlideCommand.prototype['is_topline'] = undefined;

/**
 * @member {Array.<module:model/BatchSlideInfo>} slides
 */
BatchCreateMediaSlideCommand.prototype['slides'] = undefined;
var _default = exports.default = BatchCreateMediaSlideCommand;